"use strict";

exports.__esModule = true;
exports.StyledProgressBar = exports.Bar = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _polished = require("polished");

var _ValueBar = _interopRequireDefault(require("../ValueBar/ValueBar"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getBorderRadius = height => {
  const [value, units] = (0, _polished.getValueAndUnit)(height);
  return `${value / 2}${units}`;
};

const StyledProgressBar = (0, _styledComponents.default)(({
  children,
  height,
  outlineColor,
  showTrack,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", { ...otherProps,
  children: children
}))`
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: ${props => props.height};
    border-radius: ${props => getBorderRadius(props.height)};
    border: ${props => `1px solid ${props.showTrack ? props.outlineColor : 'transparent'}`};
`;
exports.StyledProgressBar = StyledProgressBar;
const Bar = (0, _styledComponents.default)(_ValueBar.default)`
    transition: width 250ms;
`;
exports.Bar = Bar;